// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YokPq","largestCol":"styles_largestCol__3itJo","smallestCol":"styles_smallestCol__2gzU-"};